module.exports = __webpack_public_path__ + "static/assets/0c22ee0fc308a42d3feb212c82360320.svg";